<div class="crud-item-page">
  <form [formGroup]="form">
    <div class="crud-item-section">

      <span>
        <mat-form-field matTooltip="Firearm Storage Location Id"
          [matTooltipDisabled]="disabledTooltip(this.firearmStorageLocationId)">
          <mat-label i18n="@@type.FirearmStorageLocation.firearmStorageLocationId">Firearm Storage Location
            Id</mat-label>
          <input matInput formControlName="firearmStorageLocationId" id="firearmStorageLocationId"
            (ngModelChange)="firearmStorageLocationIdChanging($event)" [(ngModel)]="item.firearmStorageLocationId"
            (ngModelChange)="firearmStorageLocationIdChanged($event)" #firearmStorageLocationId type="number"
            placeholder="Firearm Storage Location Id">
        </mat-form-field>
      </span>
      
      <span>
        <mat-form-field matTooltip="Email" [matTooltipDisabled]="disabledTooltip(this.email)">
          <mat-label i18n="@@type.FirearmStorageLocation.email">Email</mat-label>
          <input matInput formControlName="email" id="email"              
              (ngModelChange)="emailChanging($event)" [(ngModel)]="item.email"              
              (ngModelChange)="emailChanged($event)" #email              
              maxlength="255" placeholder="Email">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Select a Business Unit from the list"
          [matTooltipDisabled]="disabledTooltip(this.businessUnit)">
          <mat-label i18n="@@type.FirearmStorageLocation.businessUnit">Business Unit</mat-label>
          <mat-select formControlName="businessUnit" id="businessUnit" (ngModelChange)="businessUnitChanging($event)"
            [(ngModel)]="item.businessUnit" (ngModelChange)="businessUnitChanged($event)" #businessUnit
            placeholder="Business Unit" [compareWith]="businessUnitCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let businessUnit of businessUnitSelectionList" [value]="businessUnit">
              {{businessUnitDisplay(businessUnit)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Location" [matTooltipDisabled]="disabledTooltip(this.location)">
          <mat-label i18n="@@type.FirearmStorageLocation.location">Location</mat-label>
          <input matInput formControlName="location" id="location" (ngModelChange)="locationChanging($event)"
            [(ngModel)]="item.location" (ngModelChange)="locationChanged($event)" #location maxlength="255"
            placeholder="Location">
        </mat-form-field>
      </span>
      <span>
        <mat-form-field matTooltip="Select a Location Type from the list" [matTooltipDisabled]="disabledTooltip(this.locationType)">
          <mat-label i18n="@@type.FirearmStorageLocation.locationType">Location Type</mat-label>
          <mat-select formControlName="locationType" id="locationType"              
              (ngModelChange)="locationTypeChanging($event)" [(ngModel)]="item.locationType"              
              (ngModelChange)="locationTypeChanged($event)" #locationType              
              placeholder="Location Type">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let locationType of locationTypeSelectionList" [value]="locationType.code">
              {{locationType.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>
      <span>
        <span>
          <mat-slide-toggle floatLabel="always" appearance="none" color="primary"
              formControlName="disposalLocation" id="disposalLocation"              
              (ngModelChange)="disposalLocationChanging($event)" [(ngModel)]="item.disposalLocation"              
              (ngModelChange)="disposalLocationChanged($event)" #disposalLocation i18n="@@type.FirearmStorageLocation.disposalLocation">
Disposal Location          </mat-slide-toggle>        
        </span>
      </span>
    </div>
    <mat-divider></mat-divider>

    <div class="crud-item-section">

      <span>
        <mat-form-field matTooltip="Description" [matTooltipDisabled]="disabledTooltip(this.description)"
          class="crud-item-input-verywide">
          <mat-label i18n="@@type.FirearmStorageLocation.description">Description</mat-label>
          <textarea matInput formControlName="description" id="description"
            (ngModelChange)="descriptionChanging($event)" [(ngModel)]="item.description"
            (ngModelChange)="descriptionChanged($event)" #description maxlength="2000"
            placeholder="Description"></textarea>
        </mat-form-field>
      </span>

    </div>
    
    <mat-divider></mat-divider>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Addr1" [matTooltipDisabled]="disabledTooltip(this.addr1)"
          class="crud-item-input-wide">
          <mat-label i18n="@@type.FirearmStorageLocation.addr1">Addr1</mat-label>
          <input matInput formControlName="addr1" id="addr1" (ngModelChange)="addr1Changing($event)"
            [(ngModel)]="item.addr1" (ngModelChange)="addr1Changed($event)" #addr1 maxlength="255" placeholder="Addr1">
        </mat-form-field>
      </span>
    </div>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Addr2" [matTooltipDisabled]="disabledTooltip(this.addr2)"
          class="crud-item-input-wide">
          <mat-label i18n="@@type.FirearmStorageLocation.addr2">Addr2</mat-label>
          <input matInput formControlName="addr2" id="addr2" (ngModelChange)="addr2Changing($event)"
            [(ngModel)]="item.addr2" (ngModelChange)="addr2Changed($event)" #addr2 maxlength="255" placeholder="Addr2">
        </mat-form-field>
      </span>
    </div>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Addr3" [matTooltipDisabled]="disabledTooltip(this.addr3)"
          class="crud-item-input-wide" class="crud-item-input-wide">
          <mat-label i18n="@@type.FirearmStorageLocation.addr3">Addr3</mat-label>
          <input matInput formControlName="addr3" id="addr3" (ngModelChange)="addr3Changing($event)"
            [(ngModel)]="item.addr3" (ngModelChange)="addr3Changed($event)" #addr3 maxlength="255" placeholder="Addr3">
        </mat-form-field>
      </span>
    </div>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Town" [matTooltipDisabled]="disabledTooltip(this.town)"
          class="crud-item-input-wider">
          <mat-label i18n="@@type.FirearmStorageLocation.town">Town</mat-label>
          <input matInput formControlName="town" id="town" (ngModelChange)="townChanging($event)"
            [(ngModel)]="item.town" (ngModelChange)="townChanged($event)" #town maxlength="255" placeholder="Town">
        </mat-form-field>
      </span>
    </div>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="County" [matTooltipDisabled]="disabledTooltip(this.county)"
          class="crud-item-input-wider">
          <mat-label i18n="@@type.FirearmStorageLocation.county">County</mat-label>
          <input matInput formControlName="county" id="county" (ngModelChange)="countyChanging($event)"
            [(ngModel)]="item.county" (ngModelChange)="countyChanged($event)" #county maxlength="255"
            placeholder="County">
        </mat-form-field>
      </span>
    </div>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Postcode" [matTooltipDisabled]="disabledTooltip(this.postcode)">
          <mat-label i18n="@@type.FirearmStorageLocation.postcode">Postcode</mat-label>
          <input matInput formControlName="postcode" id="postcode" (ngModelChange)="postcodeChanging($event)"
            [(ngModel)]="item.postcode" (ngModelChange)="postcodeChanged($event)" #postcode maxlength="8"
            placeholder="Postcode">
        </mat-form-field>
      </span>
    </div>

    <mat-divider></mat-divider>

    <div class="crud-item-section">


      <span>
        <mat-form-field matTooltip="Created By" [matTooltipDisabled]="disabledTooltip(this.createdBy)">
          <mat-label i18n="@@type.FirearmStorageLocation.createdBy">Created By</mat-label>
          <input matInput formControlName="createdBy" id="createdBy" (ngModelChange)="createdByChanging($event)"
            [(ngModel)]="item.createdBy" (ngModelChange)="createdByChanged($event)" #createdBy maxlength="255"
            placeholder="Created By">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Created Date" [matTooltipDisabled]="disabledTooltip(this.createdDate)">
          <mat-label i18n="@@type.FirearmStorageLocation.createdDate">Created Date</mat-label>
          <input matInput formControlName="createdDate" id="createdDate" (ngModelChange)="createdDateChanging($event)"
            [(ngModel)]="item.createdDate" (ngModelChange)="createdDateChanged($event)" #createdDate
            [matDatepicker]="createdDateDatePicker" placeholder="Created Date">
          <mat-datepicker-toggle matSuffix [for]="createdDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #createdDateDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Updated By" [matTooltipDisabled]="disabledTooltip(this.updatedBy)">
          <mat-label i18n="@@type.FirearmStorageLocation.updatedBy">Updated By</mat-label>
          <input matInput formControlName="updatedBy" id="updatedBy" (ngModelChange)="updatedByChanging($event)"
            [(ngModel)]="item.updatedBy" (ngModelChange)="updatedByChanged($event)" #updatedBy maxlength="255"
            placeholder="Updated By">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Updated Date" [matTooltipDisabled]="disabledTooltip(this.updatedDate)">
          <mat-label i18n="@@type.FirearmStorageLocation.updatedDate">Updated Date</mat-label>
          <input matInput formControlName="updatedDate" id="updatedDate" (ngModelChange)="updatedDateChanging($event)"
            [(ngModel)]="item.updatedDate" (ngModelChange)="updatedDateChanged($event)" #updatedDate
            [matDatepicker]="updatedDateDatePicker" placeholder="Updated Date">
          <mat-datepicker-toggle matSuffix [for]="updatedDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #updatedDateDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
      </span>

    </div>
    <mat-divider></mat-divider>

  </form>
</div>